export enum TabularDataGridSize {
  Min,
  Medium,
  Max,
}
